<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="student"></HeaderRow>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/student">学员优作</el-breadcrumb-item>
						<el-breadcrumb-item @click="backtoList">{{ group.group_name }} </el-breadcrumb-item>
						<el-breadcrumb-item>详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="content">
					<div class="article">
						<div class="titleBox">
							<h1>{{ detail.title }}</h1>
							<div class="sub">
								<span>{{ detail.student }}</span>
								<span>{{ detail.created_at }}</span>
								<i class="el-icon-view">{{ detail.show_num }}</i>
								<i class="el-icon-thumb" @click="addLike">{{ detail.likes_num }}</i>
								<i class="el-icon-chat-square" @click="addComment">{{ detail.comments_num }}</i>
							</div>
						</div>
						<div class="contentBox">
							<img v-if="detail.images" :src="detail.images"></img>
							<div v-html="detail.content">
							</div>
						</div>
						<div class="comment">
							<div class="title">
								<span>评论（{{ detail.comments_num }}）</span>
							</div>
							<div class="textarea">
								<el-input type="textarea" :rows="2" placeholder="请输入评论" v-model="commentVal">
								</el-input>
								<button type="button" @click="addComment()">提交</button>
							</div>
							<div class="commentList">
								<div class="commentRow" v-for="item in comment" :key="item.id">
									<img mode="widthFix" :src="item.avatar"></img>
									<div class="rowRight">
										<div>
											<span>{{item.nickname||'昵称'}}</span>
											<span>{{item.created_at}}</span>
										</div>
										<div>
											<span>{{item.content}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="watching">
						<div class="title">
							<i class="el-icon-thumb"></i>
							<span>大家都在看</span>
						</div>
						<div class="subList">
							<div class="subItem" v-for="sub in suggest" :key="sub.article_id" @click="gotoStDetail(sub.article_id)">
								<p><span>{{ sub.title }}</span></p>
							</div>
						</div>
					</div>
				</div>

			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./";
	import {
		copy
	} from "clipboard";
	import FooterRow from "@/components/footerRow.vue";
	import LoginDialog from "@/components/loginDialog.vue";
	import HeaderRow from "@/components/headerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
			LoginDialog
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "index";
</style>